/**
 * Post-sign-in destination carried through onboarding (#830, #3517).
 *
 * A brand-new account is covered by the OnboardingModal right after sign-in,
 * and that modal decides where to go when it finishes. It reads this key
 * first (`OnboardingModal.resolveDestination`), so every sign-in path that
 * can create a new account must write it: the email magic link
 * (`MagicLoginPage`) and the SMS code (`LoginModal`). Without it, a visitor
 * who chose "Set up your next event" finishes onboarding on their club page.
 */
export const PENDING_NAV_KEY = 'oromove:pendingNavigation';

/**
 * Hand the post-sign-in destination to onboarding, or clear it.
 *
 * Writes only for a user onboarding will cover AND a destination to hand it.
 * Every other sign-in removes the key: an onboarded user navigates directly,
 * so OnboardingModal never consumes it, and a new user with no destination
 * would otherwise inherit an earlier visitor's (Codex cloud P2 x2 + George
 * F9 on PR #3530).
 * A no-op where sessionStorage is unavailable.
 */
export function handOffPendingNavigation(
  destination: string | null | undefined,
  needsOnboarding: boolean,
): void {
  try {
    if (destination && needsOnboarding) {
      sessionStorage.setItem(PENDING_NAV_KEY, destination);
    } else {
      sessionStorage.removeItem(PENDING_NAV_KEY);
    }
  } catch {
    // Privacy modes: onboarding falls back to its context-based routing.
  }
}
